'use client';
import TechnologyFaq from '@/components/technologies/technology-faq';
import dynamic from 'next/dynamic';

import CaseStudies from '@/components/common/case-study-section';
import ClientTestimonials from '@/components/home/client-testimonials';
import WhyChooseUs from '@/components/technologies/why-choose-us';
import DefaultBreadcrumb from '@/components/common/breadcrumbs';
import MetaTags from '@/components/meta-tag/meta-tag';
import OdooServies from '@/components/technologies/odoo-services';
import OdooDevelopmentServies from '@/components/technologies/odoo-development-services';
import OdooImplementationPacks from '@/components/technologies/odoo-implementation-packs';
import OdooFAQ from '@/components/faqs/odoo-faq';
import MowebOdooDevelopmentServies from '@/components/technologies/moweb-odoo-development-services';
import OdooDevelopmentAnimation from '@/components/technologies/odoo-development-animation';
import Blog from '@/components/home/blog';

const ContactInfo = dynamic(() => import('@/components/common/contact-info'));
const ContactForm = dynamic(() => import('@/components/common/contact-form'));
const TechHero = dynamic(() => import('@/components/technologies/tech-hero'));
const ContetVideoSection = dynamic(() => import('@/components/common/content-video-odoo'));
const Page = () => {
    return (
        <>
            <MetaTags />
            {}
            <TechHero
                className="odoo-baneer-img-height"
                desc="Enhance Efficiency, Innovation, and Growth with Our Expert Odoo Development Services."
                alt="Odoo"
                title="Odoo"
                width={1090}
                height={604}
                path={'odoo-hero'}
                bgPath={'hero-bg-grunge-green'}
                color="green"
                isGreen={true}
            >
                Lead the Market with Odoo <div>ERP</div>
            </TechHero>

            <DefaultBreadcrumb parentPage="Services" isParent={true} currentPage="Odoo Development" />
            <ContetVideoSection title="Streamline and Scale with Powerful Odoo ERP Solutions" />

            <OdooDevelopmentAnimation />
            <OdooDevelopmentServies />
            <OdooServies />
            <OdooImplementationPacks />

            <MowebOdooDevelopmentServies />
            <WhyChooseUs pageTitle="Here's Why You Should Hire Moweb for Odoo Development Excellence" />
            <TechnologyFaq title="FAQs On Odoo Development Services" bg="bg-vuejs">
                <OdooFAQ />
            </TechnologyFaq>
            <CaseStudies />
            <section className="">
                <ClientTestimonials />
            </section>
            <Blog />
            <div className="section bg-primary py-100 dark:text-light dark:bg-black">
                <div className="container lg:container md:mx-auto">
                    <div className="row grid md:grid-cols-12 lg:grid-cols-12">
                        <ContactForm />
                        <ContactInfo />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Page;
